import { createAction } from '@reduxjs/toolkit';
import {
  RequestApiDataFailedPayload,
  RequestApiDataIfNecessaryPayload,
  RequestApiDataSuccessPayload,
} from './api.types';

/**
 * Triggers a check to fetch the data if it is not present or if it is stale.
 */
export const requestDataIfNecessary = createAction<
  RequestApiDataIfNecessaryPayload,
  'api/REQUEST_DATA_IF_NECESSARY'
>('api/REQUEST_DATA_IF_NECESSARY');

export const markRequestAsPending =
  createAction<RequestApiDataIfNecessaryPayload>('api/MARK_REQUEST_AS_PENDING');

/**
 * Marks a loaded resource as invalidated.
 * An invalidated resource is present but should be loaded again if
 * 'requestDataIfNecessary' action is dispatched.
 */
export const invalidateLoadedResourceIfPresent = createAction<
  {
    resourceId: string;
  },
  'api/INVALIDATE_LOADED_RESOURCE_IF_PRESENT'
>('api/INVALIDATE_LOADED_RESOURCE_IF_PRESENT');

/**
 * Used internally to signals a failed request.
 * Do not dispatch it directly.
 */
export const apiRequestFailed = createAction<
  RequestApiDataFailedPayload,
  'api/REQUEST_FAILED'
>('api/REQUEST_FAILED');

/**
 * Used internally to signals a successful request.
 * Do not dispatch it directly.
 */
export const apiRequestSuccess = createAction<
  RequestApiDataSuccessPayload,
  'api/REQUEST_SUCCESS'
>('api/REQUEST_SUCCESS');
